<template>
    <div class="page"
        v-for="(buildingids, page) in splitToPages(Object.keys(nsrData).sort((a, b) => nsrData[a].nsrname.localeCompare(nsrData[b].nsrname, undefined, { numeric: true, sensitivity: 'base' })), 15, 15)">
        <div class="formgrid grid">
            <div class="field col-12 md:col-12" style="margin-bottom:5px;font-weight: bold;" v-if="page == 0">
                {{ title }}
            </div>
            <div class="field col-12 md:col-12">
                <table class="table" id="gantt">
                    <tr>
                        <th></th>
                        <template v-for="year in getYearBetweenDates(project.commencementDate, project.completionDate)">
                            <th
                                :colspan="getMonthsBetweenDates(project.commencementDate, project.completionDate).filter(m => m.getFullYear() === year.getFullYear()).length">
                                {{
                                    year.getFullYear()
                                }}</th>
                        </template>
                    </tr>
                    <tr>
                        <th>NSR Label</th>
                        <template v-for="year in getYearBetweenDates(project.commencementDate, project.completionDate)">
                            <template
                                v-for="month in getMonthsBetweenDates(project.commencementDate, project.completionDate).filter(m => m.getFullYear() === year.getFullYear())">
                                <th style="text-align: center;">{{ (month.getMonth() + 1).toString().padStart(2,
                                    '0')
                                }}
                                </th>
                            </template>
                        </template>
                    </tr>
                    <template v-for="id in buildingids">
                        <tr>
                            <td>{{ nsrData[id].nsrname }}</td>
                            <template v-for="year in getYearBetweenDates(project.commencementDate, project.completionDate)">
                                <template
                                    v-for="month in getMonthsBetweenDates(project.commencementDate, project.completionDate).filter(m => m.getFullYear() === year.getFullYear())">
                                    <td v-if="getNoiseCriteriaBetweenDates(id, new
                                        Date(month.getFullYear(), month.getMonth(), 1), new Date(month.getFullYear(),
                                            month.getMonth() + 1, 0)) > nsrData[id].noiseCriteria" class="greyCell">
                                        {{ Math.round(getNoiseCriteriaBetweenDates(id, new
                                            Date(month.getFullYear(), month.getMonth(), 1), new Date(month.getFullYear(),
                                                month.getMonth() + 1, 0))) }}
                                    </td>
                                    <td v-else-if="getNoiseCriteriaBetweenDates(id, new
                                        Date(month.getFullYear(), month.getMonth(), 1), new Date(month.getFullYear(),
                                            month.getMonth() + 1, 0))">
                                        {{ Math.round(getNoiseCriteriaBetweenDates(id, new
                                            Date(month.getFullYear(), month.getMonth(), 1), new Date(month.getFullYear(),
                                                month.getMonth() + 1, 0))) }}
                                    </td>
                                    <td v-else></td>
                                </template>
                            </template>
                        </tr>
                    </template>
                </table>
            </div>
            <div class="formgrid grid" v-if="start && end" style="width:100%;margin-left: 10px;">
                <div class="field col-12 md:col-1 darkgreyCell">
                </div>
                <div class="field col-12 md:col-11">
                    {{ legend }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InputLabel from "./InputLabel.vue"
import DropdownLabel from "./DropdownLabel.vue"
import DateHelper from "@/helper/DateHelper"
import { transformWithProjections } from "ol/proj"
export default {
    name: 'ReportNoiseGantt',
    props: {
        project: Object,
        nsrData: Object,
        title: String,
        legend: String,
        start: Array,
        end: Array
    },
    computed: {
        getTotalDays() {
            return (DateHelper.getDate(this.project.completionDate).getTime() - DateHelper.getDate(this.project.commencementDate).getTime()) / (1000 * 3600 * 24)
        },
        getTotalWeeks() {
            return (DateHelper.getDate(this.project.completionDate).getTime() - DateHelper.getDate(this.project.commencementDate).getTime()) / (1000 * 3600 * 24 * 7)
        },
        getTotalMonths() {
            let d1 = DateHelper.getDate(this.project.commencementDate);
            let d2 = DateHelper.getDate(this.project.completionDate);
            let months;
            months = (d2.getFullYear() - d1.getFullYear()) * 12;
            months -= d1.getMonth();
            months += d2.getMonth();
            return months <= 0 ? 0 : months;
        },
    },
    methods: {
        getDateString(date) {
            return DateHelper.getDateString(date);
        },
        getDaysBetweenDates(start, end) {
            start = DateHelper.getDate(start);
            end = DateHelper.getDate(end);
            var days = [];
            while (start <= end) {
                days.push(new Date(start.getFullYear(), start.getMonth(), start.getDate()));
                start.setDate(start.getDate() + 1);
            }
            return days;
        },
        getWeeksBetweenDates(start, end) {
            start = DateHelper.getDate(start);
            end = DateHelper.getDate(end);
            var weeks = [];
            while (start <= end) {
                weeks.push(new Date(start.getFullYear(), start.getMonth(), start.getDate()));
                start.setDate(start.getDate() + 7);
            }
            return weeks;
        },
        getMonthsBetweenDates(start, end) {
            start = DateHelper.getDate(start);
            end = DateHelper.getDate(end);
            var date = new Date(start.getFullYear(), start.getMonth(), 1);
            var months = [];
            while (date <= new Date(end.getFullYear(), end.getMonth(), 1)) {
                months.push(new Date(date.getFullYear(), date.getMonth(), 1));
                date.setMonth(date.getMonth() + 1);
            }
            return months;
        },
        getYearBetweenDates(start, end) {
            start = DateHelper.getDate(start);
            end = DateHelper.getDate(end);
            var date = new Date(start.getFullYear(), 0, 1);
            var years = [];
            while (date <= new Date(end.getFullYear(), 0, 1)) {
                years.push(new Date(date.getFullYear(), 0, 1));
                date.setYear(date.getFullYear() + 1);
            }
            return years;
        },
        getDate(date) {
            return DateHelper.getDate(date)
        },
        isDateBetweenDates(target, start, end) {
            if (!start || !end) return false;
            start = start.map(d => DateHelper.getDate(d));
            end = end.map(d => DateHelper.getDate(d));
            target = DateHelper.getDate(target);
            let result = false;
            for (var i = 0; i < start.length; i++) {
                result = result || (target >= start[i] && target <= end[i]);
            }
            return result;
        },
        getCombineTasksBetweenDates(start, end) {
            let tasks = []
            this.project.tasks.forEach(task => {
                if (this.isDateBetweenDates(start, [task.start], [task.end])
                    || this.isDateBetweenDates(start, [task.start], [task.end])
                    || this.isDateBetweenDates(end, [task.start], [task.end])
                    || this.isDateBetweenDates(end, [task.start], [task.end])) {
                    tasks.push(`${task.zone}-${task.id}`);
                }
            })
            tasks.sort();
            return tasks.join("+");
        },
        getNoiseCriteriaBetweenDates(id, start, end) {
            let zonetaskorcombined = this.nsrData[id].zonetaskorcombined[this.getCombineTasksBetweenDates(start, end)]
            if (zonetaskorcombined)
                return zonetaskorcombined.cnl
            else
                return undefined;
        },
        splitToPages(list, firstPageCount, otherPageCount) {
            let pages = []
            let sublist = [];
            for (var i = 0; i < list.length; i++) {
                if ((i + 1 - firstPageCount) % otherPageCount == 0) {
                    sublist.push(list[i])
                    pages.push(sublist);
                    sublist = [];
                }
                else {
                    sublist.push(list[i])
                }
            }
            if (sublist.length > 0) {
                pages.push(sublist);
            }
            return pages;
        },
        numberToLetter(num) {
            var s = '';
            var t;
            while (num > 0) {
                t = (num - 1) % 26;
                s = String.fromCharCode(65 + t) + s;
                num = (num - t) / 26 | 0;
            }
            return s;
        },
        getCombinationString(combination) {
            return combination.split('+').map(c => this.numberToLetter(this.project.tasks.indexOf(this.project.tasks.filter(t => t.id == c.split("-")[1])[0]) + 1)).sort().join('+');
        }
    },
    mounted() {
    },
    components: {
        InputLabel,
        DropdownLabel
    }
}
</script>

<style lang="less" scoped>
.appendix {
    font-family: 'Times New Roman', Times, serif;
    text-align: left;
    color: black;
}

.center {
    text-align: center;
    width: 100%;
}

.page {
    width: 100%;
    height: auto;
    aspect-ratio: 841.89 / 592.28;
    padding: 20px 25px;
}

.cover {
    text-align: right;
    position: absolute;
    top: 50%;
    transform: translate(0%, -50%);
    width: 90%;
}

.table {
    width: 100%;
    font-size: 12px;
    margin-bottom: 10px;
}

table,
th,
td {
    border: 1px solid black;
    border-collapse: collapse;
}

td {
    padding: 3px
}

.header {
    text-align: center;
    width: 100%;
}

.header>th {
    background-color: rgb(172, 172, 172);
    font-size: 12px;
}

.sub-header {
    text-align: center;
    font-weight: bold;
}

.cell {
    width: 100%;
}

.greyCell {
    background-color: rgb(172, 172, 172);
}

.darkgreyCell {
    background-color: rgb(91, 91, 91);
}


#gantt>tr>td:first-child {
    width: 33%;
}

.number {
    text-align: center
}
</style>